<template>
	<div>

		<div class="fd-nav-content">
			<section class="dingflow-design">
				<div class="zoom">
					<div :class="'zoom-out'+ (nowVal==50?' disabled':'')" @click="zoomSize(1)"></div>
					<span>{{nowVal}}%</span>
					<div :class="'zoom-in'+ (nowVal==300?' disabled':'')" @click="zoomSize(2)"></div>
				</div>
				<div class="box-scale" id="box-scale" :style="'transform: scale('+nowVal/100+'); transform-origin: 50% 0px 0px;'">
					<nodeWrap :nodeConfig.sync="nodeConfig" :flowPermission.sync="flowPermission"
						:isTried.sync="isTried" :tableId="tableId"></nodeWrap>
					<div class="end-node">
						<div class="end-node-circle"></div>
						<div class="end-node-text">流程结束</div>
					</div>
				</div>
			</section>
		</div>
		<errorDialog 
			:visible.sync="tipVisible"
			:list="tipList"	
		/>
		<promoterDrawer />
		<approverDrawer  :directorMaxLevel="directorMaxLevel"/>
		<copyerDrawer />
		<conditionDrawer />
	</div>
</template>
<script>
import errorDialog from '@/components/flow/newProcess/dialog/errorDialog'
import promoterDrawer from '@/components/flow/newProcess/drawer/promoterDrawer'
import approverDrawer from '@/components/flow/newProcess/drawer/approverDrawer'
import copyerDrawer from '@/components/flow/newProcess/drawer/copyerDrawer'
import conditionDrawer from '@/components/flow/newProcess/drawer/conditionDrawer'
export default {
	props: {
		Design: {
		type: Object,
		 default: null
		}
    },
	components:{
		errorDialog,
		promoterDrawer,
		approverDrawer,
		copyerDrawer,
		conditionDrawer
	},
	data() {
		return {
			api: require("@/api/process/design").default,
			isTried: false,
			tipList: [],
			tipVisible: false,
			nowVal: 100,
			processConfig: {
				directorMaxLevel:0,
				flowPermission:[],
				nodeConfig:{
					ccSelfSelectFlag: "",
					childNode: {},
					conditionList: [],
					conditionNodes: [],
					directorLevel: "",
					examineEndDirectorLevel: "",
					examineMode: "",
					noHanderAction: "",
					nodeName: "发起人",
					nodeUserList: {},
					priorityLevel: "",
					selectMode: "",
					selectRange: "",
					settype: "",
					type: 0
				},
				tableId:0,
				workFlowDef:{}
			},
			nodeConfig: {type:''},
			workFlowDef: {},
			flowPermission: [],
			directorMaxLevel: 0,
			tableId: "",
			formData: {},
		};
	},
	watch:{
    Design:{
      handler (val) {
		  if(val){
       	   let data = val
            this.processConfig = data;
			let {nodeConfig,flowPermission,directorMaxLevel,workFlowDef,tableId} = data
			this.nodeConfig = nodeConfig;
			this.flowPermission = flowPermission;
			this.directorMaxLevel = directorMaxLevel;
			this.workFlowDef = workFlowDef
			this.tableId = tableId
		  }
      },
      immediate: true
    },

  },
	created() {
		// console.log(`/data.json`)
	// 	if(this.$route.query.id){
	// 		let id=this.$route.query.id
    //    this.api.info(id).then((row) => {
	// 	   console.log(row)
	// 	   let data = row.Data.Design
    //         this.processConfig = data;
	// 		let {nodeConfig,flowPermission,directorMaxLevel,workFlowDef,tableId} = data
	// 		this.nodeConfig = nodeConfig;
	// 		this.flowPermission = flowPermission;
	// 		this.directorMaxLevel = directorMaxLevel;
	// 		this.workFlowDef = workFlowDef
	// 		this.tableId = tableId
	//    })
	// 	}
		this.$axios.get('../data.json').then((row) => {
			// console.log(row)
			let data = row.data.data
            this.processConfig = data;
			let {nodeConfig,flowPermission,directorMaxLevel,workFlowDef,tableId} = data
			this.nodeConfig = nodeConfig;
			this.flowPermission = flowPermission;
			this.directorMaxLevel = directorMaxLevel;
			this.workFlowDef = workFlowDef
			this.tableId = tableId
            });
//      this.api.list({ "PageIndex": 1,
//   "PageSize": 10,}).then(res => {
//       console.log(res)
//         })
		// this.$axios.get(`${process.env.BASE_URL}data.json`, {
		// 	workFlowDefId: this.$route.params.workFlowDefId
		// }).then(({data}) => {	
		// 	console.log(data,'lllkkk')		
		// 	this.processConfig = data;
		// 	let {nodeConfig,flowPermission,directorMaxLevel,workFlowDef,tableId} = data
		// 	this.nodeConfig = nodeConfig;
		// 	this.flowPermission = flowPermission;
		// 	this.directorMaxLevel = directorMaxLevel;
		// 	this.workFlowDef = workFlowDef
		// 	this.tableId = tableId
		// })
	},
	methods: {
		// 给父级组件提供的获取流程数据得方法
		getData(){
			this.processConfig.flowPermission = this.flowPermission
			return Promise.resolve({formData: this.processConfig})
		//   this.verifyMode = true
		//   if(NodeUtils.checkAllNode(this.data)) {
		//     return Promise.resolve({formData: this.processConfig})
		//   }else{
		//     return Promise.reject({target: this.tabName})
		//   }
		},
		toReturn() {
			//window.location.href = ""
		},
		reErr({childNode}) {
			if (childNode) {
				let {type,error,nodeName,conditionNodes} = childNode
				if (type == 1 || type == 2) {
					if (error) {
						this.tipList.push({ name: nodeName, type: ["","审核人","抄送人"][type] })
					}
					this.reErr(childNode)
				} else if (type == 3) {
					this.reErr(childNode)
				} else if (type == 4) {
					this.reErr(childNode)
					for (var i = 0; i < conditionNodes.length; i++) {
						if (conditionNodes[i].error) {
							this.tipList.push({ name: conditionNodes[i].nodeName, type: "条件" })
						}
						this.reErr(conditionNodes[i])
					}
				}
			} else {
				childNode = null
			}
		},
		saveSet() {
			this.isTried = true;
			this.tipList = [];
			this.reErr(this.nodeConfig);
			if (this.tipList.length != 0) {
				this.tipVisible = true;
				return;
			}
			this.processConfig.flowPermission = this.flowPermission
			console.log(JSON.stringify(this.processConfig))
			// this.$axios.post("", this.processConfig).then(res => {
			//     if (res.code == 200) {
			//         this.$message.success("设置成功");
			//         setTimeout(function () {
			//             window.location.href = ""
			//         }, 200)
			//     }
			// })
		},
		zoomSize(type) {
			if (type == 1) {
				if (this.nowVal == 50) {
					return;
				}
				this.nowVal -= 10;
			} else {
				if (this.nowVal == 300) {
					return;
				}
				this.nowVal += 10;
			}
		}
	}
};
</script>
<style>
@import "../../../css/workflow.css";
.error-modal-list {
	width: 455px;
}
</style>